exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".dayWrapper[data-v-f55d1132]{max-width:600px;margin:auto}.currentBlocks.flexRow[data-v-f55d1132]{max-width:65%}.flexRow.category[data-v-f55d1132]{margin:.75rem}.flexRow.category.parent[data-v-f55d1132]{margin-bottom:0}.flexRow.subcategory[data-v-f55d1132]{margin:0 .75rem}.editLink[data-v-f55d1132]{font-size:.75rem;text-decoration:none;cursor:pointer;color:#ccc}.editLink[data-v-f55d1132]:hover{color:#3498db}.dayToggle>a[data-v-f55d1132]{margin:0 .75rem}@media (max-width:600px){.flexRow.category[data-v-f55d1132]{margin:.25rem}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-f55d1132&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=1!./dev/src/views/DayView.vue
// module id = ./node_modules/css-loader/index.js?minimize!./node_modules/vue-loader/lib/style-rewriter.js?id=data-v-f55d1132&scoped=true!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./dev/src/views/DayView.vue
// module chunks = 0